import Facet from "../../types/funnelback/Facets";
import composeFieldName from "./composeFieldName";
import { getFacetParamName } from "../../utils/facetParams";

export const getFacetParamKey = (facet: Facet): string => getFacetParamName(facet);

export const getFieldNameFromFacetParamKey = (
    facetParamKey: string
): string => {
    const facetFieldKey = composeFieldName(facetParamKey);
    switch (facetFieldKey) {
        case "d":
            return "datePublished";
        default:
            return facetFieldKey;
    }
};

export const findFacetByFieldName = (
    fieldName: string,
    facets: Facet[]
): Facet | null => {
    if (!facets.length) {
        return null;
    }

    const matchingFacet = facets.find((facet) => {
        const facetParamKey = getFacetParamName(facet);
        if (!facetParamKey) {
            return false;
        }
        const facetFieldName = getFieldNameFromFacetParamKey(facetParamKey);
        return facetFieldName === fieldName;
    });
    return matchingFacet ? matchingFacet : null;
};

const findFacetByParamKey = (
    paramKey: string,
    facets: Facet[]
): Facet | null => {
    if (!facets.length) {
        return null;
    }
    const matchingFacet = facets.find((facet) => {
        return getFacetParamName(facet) === paramKey;
    });
    return matchingFacet ? matchingFacet : null;
};

export default findFacetByParamKey;
